'use strict';

(function () {
  const SWIPER_SELECTOR = '.blog-tabheader__slider.swiper[data-section-id]';

  const getAllSliders = (root = document) => Array.from(root.querySelectorAll(SWIPER_SELECTOR));

  const initSlider = (el) => {
    if (!el || typeof Swiper === 'undefined') return;
    if (el.__blogTabheaderSwiper) return;

    const block = el.closest('.blog-tabheader');
    const prevBtn = block?.querySelector('.swiper-button-prev') || null;
    const nextBtn = block?.querySelector('.swiper-button-next') || null;
    const scrollbar = el.querySelector('.swiper-scrollbar') || null;

    const updateNavigation = (swiper) => {
      if (!prevBtn || !nextBtn) return;

      if (swiper.isBeginning) prevBtn.classList.add('disabled');
      else prevBtn.classList.remove('disabled');

      if (swiper.isEnd) nextBtn.classList.add('disabled');
      else nextBtn.classList.remove('disabled');
    };

    el.__blogTabheaderSwiper = new Swiper(el, {
      slidesPerView: 'auto',
      spaceBetween: 16,
      freeMode: { enabled: true, sticky: false },
      watchOverflow: true,
      grabCursor: true,
      observer: true,
      observeParents: true,
      navigation:
        prevBtn && nextBtn
          ? {
              prevEl: prevBtn,
              nextEl: nextBtn,
              disabledClass: 'disabled',
            }
          : false,
      scrollbar: scrollbar
        ? {
            el: scrollbar,
            draggable: true,
          }
        : false,
      on: {
        init: function () {
          updateNavigation(this);
        },
        slideChange: function () {
          updateNavigation(this);
        },
        resize: function () {
          updateNavigation(this);
        },
        lock: function () {
          updateNavigation(this);
        },
        unlock: function () {
          updateNavigation(this);
        },
      },
    });
  };

  const destroySlider = (el) => {
    if (!el || !el.__blogTabheaderSwiper) return;
    el.__blogTabheaderSwiper.destroy(true, true);
    el.__blogTabheaderSwiper = null;
  };

  const initAll = () => {
    getAllSliders().forEach(initSlider);
  };

  const initBySectionId = (sectionId) => {
    getAllSliders().forEach((el) => {
      if (el.dataset.sectionId === sectionId) initSlider(el);
    });
  };

  const destroyBySectionId = (sectionId) => {
    getAllSliders().forEach((el) => {
      if (el.dataset.sectionId === sectionId) destroySlider(el);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const sectionId = e?.detail?.sectionId;
    if (!sectionId) return;
    initBySectionId(sectionId);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const sectionId = e?.detail?.sectionId;
    if (!sectionId) return;
    destroyBySectionId(sectionId);
  });
})();

